import React, { DOMAttributes, FC } from 'react';

export const ActionColumn: FC<DOMAttributes<HTMLDivElement>> = ({ children, ...rest }) => (
  <div className="c-action__column" {...rest}>
    {children}
  </div>
);
